import { useState } from "react";
import {
  Menu,
  MenuItem,
  Button,
} from "@mui/material";

const Filterlist = ({
  options = [],
  label = "Select",
  value,
  onChange,
  isSarchRequired = false
}) => {
  // console.log("Filterlist rendered with options:", value);
  const [anchorEl, setAnchorEl] = useState(null);
  // const [ selectedFilter, setSelectedFilter ] = useState({})

  const open = Boolean(anchorEl);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (option) => {
    
    // setSelectedFilter(option);
    onChange(option);
    handleClose();
  };

  return (
    <>
      <Button
        variant="text"
        onClick={handleOpen}
        sx={{ textTransform: "none", fontWeight: 500 }}
      >
        {label}
      </Button>

      <Menu anchorEl={anchorEl} open={open} onClose={handleClose} slotProps={{
          paper: {
              sx: {
                maxHeight: 300,
                width: 260
              }
          }
      }}>
        
        {/* Options */}
        {options.map((option) => (
          <MenuItem
            key={ option.value }
            selected={value?.value === option.value}
            onClick={(e) => {
              e.stopPropagation();
              handleSelect(option);
            }}
          >
            { option.label }
          </MenuItem>
        ))}

      </Menu>
    </>
  );
};

export default Filterlist;